var map = {
	"./Alvear_GreyScale.png": 34914,
	"./Alvear_GreyScale2.png": 17164,
	"./Alvear_Negativo.png": 61130,
	"./AvatarDelivery.png": 12584,
	"./AvatarPickUp.png": 85344,
	"./AvatarPreguntasFrecuentes.png": 32212,
	"./C_HotWeek2021.png": 78473,
	"./Clientazo.png": 67024,
	"./DISTRIC.png": 17032,
	"./DISTRICT.png": 21979,
	"./Yaguane.png": 70993,
	"./Yaguane_GreyScale.png": 50624,
	"./Yaguane_Negativo.png": 81633,
	"./alvear.png": 66170,
	"./blackfriday.png": 91947,
	"./carrito.png": 86987,
	"./default_external_user.png": 1020,
	"./default_rubro.png": 51292,
	"./default_subrubro.png": 59829,
	"./default_user.png": 37064,
	"./imgDefault.png": 96447,
	"./logo.png": 96338,
	"./pedidos.png": 68050,
	"./tienda.png": 97581,
	"./whatsapp.png": 7690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57872;